import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7ef42b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header",
  class: "flex w-screen"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-green-600 absolute top-0 right-0 w-5/12 h-screen z-0" }, null, -1))
const _hoisted_3 = { class: "flex flex-col w-1/3 pl-20 justify-around" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-7xl font-semibold" }, "Théo Koël"),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl text-gray-500" }, "Curriculum Vitae")
], -1))
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = { class: "text-2xl font-medium" }
const _hoisted_7 = { href: "#monParcours" }
const _hoisted_8 = { class: "ml-5 mt-2" }
const _hoisted_9 = { href: "#mesCompetences" }
const _hoisted_10 = { class: "ml-5 mt-1" }
const _hoisted_11 = { href: "#mesExperiencePro" }
const _hoisted_12 = { class: "ml-5 mt-1" }
const _hoisted_13 = { href: "#mesProjetAcademiques" }
const _hoisted_14 = { class: "ml-5 mt-1" }
const _hoisted_15 = { href: "#mesCentresDinterets" }
const _hoisted_16 = { class: "ml-5 mt-1" }
const _hoisted_17 = { href: "#contact" }
const _hoisted_18 = { class: "ml-5 mt-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-1/3 h-auto z-10",
  src: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectLangage = _resolveComponent("SelectLangage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('header.sommaire.titre')), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t('header.sommaire.1')), 1)
          ]),
          _createElementVNode("a", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.$t('header.sommaire.2')), 1)
          ]),
          _createElementVNode("a", _hoisted_11, [
            _createElementVNode("li", _hoisted_12, _toDisplayString(_ctx.$t('header.sommaire.3')), 1)
          ]),
          _createElementVNode("a", _hoisted_13, [
            _createElementVNode("li", _hoisted_14, _toDisplayString(_ctx.$t('header.sommaire.4')), 1)
          ]),
          _createElementVNode("a", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, _toDisplayString(_ctx.$t('header.sommaire.5')), 1)
          ]),
          _createElementVNode("a", _hoisted_17, [
            _createElementVNode("li", _hoisted_18, _toDisplayString(_ctx.$t('header.sommaire.6')), 1)
          ])
        ])
      ])
    ]),
    _hoisted_19,
    _createVNode(_component_SelectLangage, { class: "w-1/6 m-5 ml-auto z-10" })
  ]))
}